module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "container-fluid mb-4 p-2 text-white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('global-nav-bar-menu')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "col-10 col-sm-12 d-table m-0 p-0"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/logo.png"),
      "alt": "ohiruneart_logo",
      "width": "auto",
      "height": "60"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title d-table-cell col-11 lead text-center text-sm-left"
  }, [_vm._v("講師用管理画面")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14a2c28d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/GlobalHeaderBar.vue
// module id = 316
// module chunks = 1